<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Calendar_Schedule.1"
    data-name="Calendar,Schedule.1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_7863" data-name="Path 7863" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_7864"
      data-name="Path 7864"
      d="M16,2V6M8,2V6M3,9H21M19,4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Z"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_7865"
      data-name="Path 7865"
      d="M7.013,12.729a.25.25,0,1,0,.251.25.249.249,0,0,0-.251-.25m5,0a.25.25,0,1,0,.251.25.249.249,0,0,0-.251-.25m5,0a.25.25,0,1,0,.251.25.249.249,0,0,0-.251-.25m-10,4a.25.25,0,1,0,.251.25.249.249,0,0,0-.251-.25m5,0a.25.25,0,1,0,.251.25.249.249,0,0,0-.251-.25"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
